module.exports = __webpack_public_path__ + "images/chosen/chosen-sprite.png";